import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

function ensureFavicon() {
  const iconHref = `${import.meta.env.BASE_URL}favicon.ico`;
  const links = document.querySelectorAll<HTMLLinkElement>(
    'link[rel="icon"], link[rel="shortcut icon"]',
  );

  links.forEach((link) => {
    if (link.type === 'image/png') return;
    if (link.getAttribute('href') !== iconHref) {
      link.setAttribute('href', iconHref);
    }
  });

  if (!links.length) {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = iconHref;
    document.head.appendChild(link);
  }
}

ensureFavicon();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
